import React, {useEffect, useState} from "react";
import './Info.scss'
import Header from "../../components/Header";
import Footer from "../../components/Footer";
let img_top = require("../../assets/mushroom/26.webp");

function Company() {

    return (
        <div style={{backgroundColor: "#fafafa"}} className={"container-info"}>
            <Header/>
            <div className="video-section">
                <img className="background-video" src={img_top}/>
                <div className="overlay-content background">
                    <div>
                        <div className={"container"}>
                            <div style={{flex: 1}}>
                                <h1 className="title">Azienda</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={"container company mt-4 mb-4"}>
                <b>La nostra storia</b><br/>
                <ul>
                    <li>Fondata nel 2017, a Parma</li>
                    <li>Iniziata come un rivenditore di permessi digitali per la raccolta funghi in un piccolo paese di
                        5,000 abitanti
                    </li>
                    <li>Si è allargata a pesca, sci di fondo e trekking</li>
                    <li>Ha acquisito in un anno tutto il mercato Italiano per la raccolta funghi e la pesca</li>
                    <li>Attualmente sta guadagnando terreno nel settore dello sci di fondo e si sta espandendo nel
                        mercato europeo.
                    </li>
                </ul>
                <b>Visione</b>
                <p>Vogliamo continuare a sviluppare il nostro modello di successo allargandoci ad altre attività sia in
                    Italia che in altri Paesi, con l'obiettivo di diventare entro 5 anni la più grande piattaforma di
                    ticketing europea per le attività all'aria aperta.</p>

                <b>Progetto</b><br/>
                <small>Geoticket è la piattaforma che connette tutti i servizi legati al mondo delle attività all'aria
                    aperta</small>
                <ul>
                    <li>Come membro ottieni il salta fila evitando le code nei punti vendita fisici</li>
                    <li>Tutte le funzionalità per le attività outdoor in una sola piattaforma</li>
                    <li>Accedi alle migliori offerte per risparmiare denaro</li>
                    <li>L'app può essere usata sia online che offline, ovunque tu vada</li>
                </ul>
            </div>
            <Footer/>
        </div>
    );
}

export default Company;